<ngx-loading-bar #loading color="#3AA36B" includeSpinner="false" height="3px"></ngx-loading-bar>

<div id="equipments-edit">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" [formGroup]="editEquipment">
      <div class="row">
        <div class="col">
          <label>
            <span>*EQUIPAMENTO</span>

            <input type="text" placeholder="Nome do equipamento" formControlName="dsProduto">
          </label>
        </div>

        <div class="col">
          <label>
            <span>*TIPO DE PRODUTO</span>

            <select formControlName="cdTpProduto">
              <option value="">Selecione o tipo de produto</option>
              <option value="1">Ativo</option>
              <option value="2">Despesa</option>
            </select>
          </label>
        </div>
      </div>

      <app-models-select (selectedBrand)="brand($event);" (selectedModel)="model($event);" [brandSelected]="brandSelected" [modelSelected]="modelSelected"></app-models-select>

      <div class="row">
        <div class="col">
          <label>
            <span>*VALOR</span>

            <input type="text" formControlName="vlProduto" currencyMask>
          </label>
        </div>

        <div class="col">
            <label>
              <span>*CÓDIGO SAP ATIVO</span>

              <input type="text" formControlName="cdsProdutoSapAtivo">
            </label>
          </div>

          <div class="col">
              <label>
                <span>*CÓDIGO SAP DESPESA</span>

                <input type="text" formControlName="cdsProdutoSapDespesa">
              </label>
            </div>

        <div class="col">
          <label>
            <span>*UNIDADE SAP</span>

            <input type="text" formControlName="cdsUnidadeSap" maxlength="3">
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <button (click)="updateEquipment();">EDITAR EQUIPAMENTO</button>
        </div>
      </div>
    </div>
  </app-new>
</div>
